import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-trapeze-label',
  templateUrl: './trapeze-label.component.html',
  styleUrls: ['./trapeze-label.component.scss']
})
export class TrapezeLabelComponent implements OnInit {

  @Input() labelValue: string;
  @Input() direction: string;

  constructor() { }

  ngOnInit() {
  }

}
